<div class="main-content">
  <div class="inbt-mother-category" *ngIf="categoryData">
    <div class="product-banner" id="caraousel-scroll">
      <ng-container *ngIf="utils.screenSizeObj.width > 768 && webBannerList?.length == 0; else loadingWebBannerListContent">
        <!-- <div  *ngFor="let item of skeletonService.generateFake(1);let i = index;">
          <ngx-skeleton height="100"></ngx-skeleton>
        </div> -->
      </ng-container>

      <ng-template #loadingWebBannerListContent>
        <div #carousel *ngIf="utils.screenSizeObj.width >768 && webBannerList" class="position-relative">
          <owl-carousel-o [options]="utils.customOptionsForBanner" (changed)="handleSlideChange($event, 'web')">
            <ng-container *ngFor="let slideData of webBannerList ;let i=index">
              <ng-template carouselSlide>
                <a [href]="slideData.link" (click)="analyticsService?.triggerLoadInitiated(categoryData && categoryData.categoryName?categoryData.categoryName:
                categoryData.brandCategoryName?categoryData.brandCategoryName :'Category'); triggerBannerClick(slideData)">
                  <img role="button"  loading="lazy" [src]="slideData.image"  [alt]="slideData.altTag">
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </ng-template>

      <ng-container *ngIf="utils.screenSizeObj.width <=768 && mobileBannerList?.length == 0; else loadingMobilebannerListContent">
        <!-- <div  *ngFor="let item of skeletonService.generateFake(1);let i = index;">
          <ngx-skeleton height="100"></ngx-skeleton>
        </div> -->
      </ng-container>

      <ng-template #loadingMobilebannerListContent>
        <div #carousel *ngIf="utils.screenSizeObj.width <=768 && mobileBannerList" class="position-relative">
          <owl-carousel-o [options]="utils.customOptionsForBanner" (changed)="handleSlideChange($event, 'mob')">
            <ng-container *ngFor="let slideData of mobileBannerList;let i=index">
              <ng-template carouselSlide>
                <a [href]="slideData.link" (click)="analyticsService?.triggerLoadInitiated(categoryData && categoryData.categoryName?categoryData.categoryName:
                categoryData.brandCategoryName?categoryData.brandCategoryName :'Category'); triggerBannerClick(slideData)">
                  <img role="button"  loading="lazy" [src]="slideData.image"  [alt]="slideData.altTag">
                </a>
              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </div>
      </ng-template>
    </div>
    <div class="power-solution">
      <div class="container">
        <div class="row justify-content-md-between">
          <div class="col-md-3">
            <h1>{{categoryData && categoryData.categoryName?categoryData.categoryName:
              categoryData.brandCategoryName?categoryData.brandCategoryName :'Category'}}</h1>
          </div>
          <div class="col-md-8">
            <p class="textJustify">{{categoryData &&
              categoryData.description?categoryData.description:categoryData.solarCategoryLandingPageDesc?categoryData.solarCategoryLandingPageDesc:'N/A'}}
            <div class="solar-freeConsult">
              <div class="btn-wrap my-5">
                <a (click)="bookConsultationModal()" class="primaryBtn">Book a free consultation</a>
              </div>
            </div>
          </div>
          <div class="energy-main d-flex justify-content-between flex-wrap">
            <div class="energy-box order-1 order-md-2" *ngFor="let attrData of categoryData.attributes">
              <img class="energy-img" loading="lazy" [src]="attrData.attributeIconImageFile"
                [alt]="attrData.attributeName ? attrData.attributeName : 'attribute image'">
              <h5>{{ attrData.attributeName ? attrData.attributeName : 'N/A' }}</h5>
              <p>{{ attrData.attributeDesc ? attrData.attributeDesc : 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="findsolution-banner" *ngIf="categoryData && smallWebBannerList && smallWebBannerList.length">
      <div class="inbt-mother-category">
        <ng-container *ngIf="utils.screenSizeObj.width > 768 && smallWebBannerList?.length == 0; else loadingsmallsmallWebBannerListContent">
          <!-- <div  *ngFor="let item of skeletonService.generateFake(1);let i = index;">
            <ngx-skeleton height="100"></ngx-skeleton>
          </div> -->
        </ng-container>

        <ng-template #loadingsmallsmallWebBannerListContent>
          <div #carousel *ngIf="utils.screenSizeObj.width >768 && smallWebBannerList" class="position-relative">
            <owl-carousel-o [options]="utils.customOptionsForSmallBanner" #owlCar>
              <ng-container *ngFor="let slideData of smallWebBannerList">
                <ng-template carouselSlide>
                  <a [href]="slideData.link" (click)="triggerBannerClick(slideData)">
                    <img role="button"  loading="lazy" [src]="slideData.image"  [alt]="slideData.altTag">
                  </a>
                </ng-template>
              </ng-container>
            </owl-carousel-o>

              <!-- Navigation Buttons -->
            <button class="owl-nav d-flex justify-content-center align-items-center owl-prev" (click)="owlCar.prev()">
              <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" focusable="false" aria-hidden="true" data-di-res-id="ca1abdf8-d437167" data-di-rand="1725952672698">
                <g fill="none" fill-rule="evenodd">
                  <g>
                    <circle cx="20" cy="20" r="20"></circle>
                    <g fill-rule="nonzero">
                      <path d="M15.179 3.173L16.043 4.077 7.765 12 16.043 19.923 15.179 20.827 5.957 12z" transform="translate(8 8)" fill="#ffffff"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
            <button class="owl-nav d-flex justify-content-center align-items-center owl-next" (click)="owlCar.next()">
              <svg class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" focusable="false" aria-hidden="true" data-di-res-id="72a6da9d-f8bd046d" data-di-rand="1725952672699">
                <g>
                  <circle cx="20" cy="20" r="20"></circle>
                  <g fill-rule="nonzero">
                    <path d="M7.957 4.077L8.821 3.173 18.043 12 8.821 20.827 7.957 19.923 16.235 12z" transform="translate(8 8)" fill="#ffffff"></path>
                  </g>
                </g>
              </svg>    
            </button>
          </div>
        </ng-template>

        <ng-container *ngIf="utils.screenSizeObj.width <=768 && smallMobileBannerList?.length == 0; else loadingsmallMobileBannerListContent">
          <!-- <div  *ngFor="let item of skeletonService.generateFake(1);let i = index;">
            <ngx-skeleton height="100"></ngx-skeleton>
          </div> -->
        </ng-container>

        <ng-template #loadingsmallMobileBannerListContent>
          <div #carousel *ngIf="utils.screenSizeObj.width <=768 && smallMobileBannerList" class="position-relative">
            <owl-carousel-o [options]="utils.customOptionsForSmallBanner">
              <ng-container *ngFor="let slideData of smallMobileBannerList">
                <ng-template carouselSlide>
                  <a [href]="slideData.link" (click)="triggerBannerClick(slideData)">
                    <img role="button"  loading="lazy" [src]="slideData.image"  [alt]="slideData.altTag">
                  </a>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </ng-template>
      </div>
    </div>
    <!-- //solarSubCategory -->
    <div class="product-details" *ngFor="let subCatData of solarSubCategory; let i=index">
      <div class="container">
        <div class="product-row">
          <div class="product-col-3" *ngIf="i%2==0 && utils.screenSizeObj.width >=768">
            <picture>
              <img loading="lazy" [src]="subCatData.subCategoryIconFile" [alt]="subCatData.subCategoryAltTag">
            </picture>
          </div>
          <div class="product-col-8">
            <div class="details">
              <h3 class="text-transform-none">{{subCatData.solarSubCategoryName?subCatData.solarSubCategoryName:'N/A'}}
              </h3>
              <picture class="product-img">
                <img loading="lazy" [src]="subCatData.subCategoryIconFile" [alt]="subCatData.subCategoryAltTag">
              </picture>
              <p class="description-desk textJustify">
                {{subCatData.solarSubCategoryDesc?subCatData.solarSubCategoryDesc:'N/A'}}
              </p>
              <ul>
                <li *ngFor="let attrData of subCatData.attributes ">
                  <img loading="lazy" [src]="attrData.attributeIconImageFile"
                    (error)="this.src='{{environment?.blobUrl}}/assets/images/product-placeholder.svg'"
                    [alt]="attrData.attributeName?attrData.attributeName:'attribute image'">
                  <span>{{attrData.attributeName?attrData.attributeName:'N/A'}}</span>
                </li>
              </ul>
              <p class="description-mob textJustify">
                {{subCatData.solarSubCategoryDesc?subCatData.solarSubCategoryDesc:'N/A'}}</p>
              <div class="btn-wrap">
                <a [routerLink]="getPlpRouteLink(subCatData)" class="primaryBtn">View Products</a>
                <a role="button" [routerLink]="getSubCatRouteLink(subCatData,false)"
                  (click)="triggerSubcategoryClicked(subCatData,false) " class="grey-btn"
                  *ngIf="utils.checkValidityOfGuid(subCatData.subCategoryLandingPageGuid)">Learn More</a>
              </div>
            </div>
          </div>
          <div class="product-col-3" *ngIf="i%2!=0 && utils.screenSizeObj.width >=768">
            <picture>
              <img loading="lazy" [src]="subCatData.subCategoryIconFile" [alt]="subCatData.subCategoryAltTag">
            </picture>
          </div>
        </div>
      </div>
    </div>
    <!-- //inbtSubcate -->
    <div class="product-details" *ngFor="let subCatData of categoryData.inbtLandingSubCategoryList; let i=index">
      <div class="container">
        <div class="product-row">
          <div class="product-col-3" *ngIf="i%2==0 && utils.screenSizeObj.width >=768">
            <picture>
              <img loading="lazy" [src]="subCatData.featureImageFile" [alt]="subCatData.featureImageAltTag">
            </picture>
          </div>
          <div class="product-col-8">
            <div class="details">
              <h3 class="text-transform-none">{{subCatData.subCategoryName?subCatData.subCategoryName:'N/A'}}</h3>
              <picture class="product-img">
                <img loading="lazy" [src]="subCatData.featureImageFile" [alt]="subCatData.featureImageAltTag">
              </picture>
              <p class="description-desk textJustify">{{subCatData.description?subCatData.description:'N/A'}}</p>
              <ul>
                <li *ngFor="let attrData of subCatData.inbtLandingSubCategoryAttributeList">
                  <img loading="lazy" [src]="attrData.attributeIconFile" (error)="this.src='{{environment?.blobUrl}}/assets/images/product-placeholder.svg'"
                    [alt]="attrData.attributeName?attrData.attributeName:'attribute image'">
                  <span>{{attrData.attributeName?attrData.attributeName:'N/A'}}</span>
                </li>
              </ul>
              <p class="description-mob textJustify">{{subCatData.description?subCatData.description:'N/A'}}</p>
              <div class="btn-wrap">
                <a [routerLink]="getPlpRouteLink(subCatData)" class="primaryBtn">View Products</a>
                <a role="button" [routerLink]="getSubCatRouteLink(subCatData,true)"
                  (click)="triggerSubcategoryClicked(subCatData,true)"
                  *ngIf="utils.checkValidityOfGuid(subCatData.subCategoryLandingGuidId)" class="grey-btn">Learn More</a>
              </div>
            </div>
          </div>
          <div class="product-col-3" *ngIf="i%2!=0 && utils.screenSizeObj.width >=768">
            <picture>
              <img loading="lazy" [src]="subCatData.featureImageFile" [alt]="subCatData.featureImageAltTag">
            </picture>
          </div>
        </div>
      </div>
    </div>
    <div class="our-product pageSubTitle bgWhite" *ngIf="productCarousalData && productCarousalData.length">
      <div class="container">
        <h3>Our Products</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="productCarousalData" [isProductCarousel]="true"
          (imageClicked)="onProductClick($event)">
        </app-carousal-page>
      </div>
    </div>
    <div *ngIf="categoryData &&categoryData.questionAnswerList &&categoryData.questionAnswerList.length">
      <div class="container">
        <app-faq-page [faqData]="categoryData.questionAnswerList"></app-faq-page>
      </div>
    </div>
    <div class="solar-system" *ngIf="bannerAreaData && bannerAreaData.researchAreaHeading">
      <div class="container">
        <h3>{{bannerAreaData.researchAreaHeading?bannerAreaData.researchAreaHeading:'N/A'}}</h3>

        <ng-container *ngIf="utils.screenSizeObj.width <=768 && bannerAreaData?.bannerList?.length == 0; else loadingbannerListContent">
          <!-- <div  *ngFor="let item of skeletonService.generateFake(1);let i = index;">
            <ngx-skeleton height="100"></ngx-skeleton>
          </div> -->
        </ng-container>

        <ng-template #loadingbannerListContent>
          <div #carousel *ngIf="bannerAreaData.bannerList && bannerAreaData.bannerList.length" class="position-relative">
            <owl-carousel-o [options]="utils.optionForBannerArea">
              <ng-container *ngFor="let slideData of bannerAreaBanners">
                <ng-template carouselSlide>
                  <a [href]="slideData.link" (click)="triggerBannerClick(slideData)">
                    <img role="button"  loading="lazy" [src]="environment?.blobUrl+slideData.image"  [alt]="slideData.altTag">
                  </a>
                </ng-template>
              </ng-container>
            </owl-carousel-o>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="blog-video pageSubTitle"
      *ngIf="categoryData.mediaList && categoryData.mediaList.length && showVideoSection">
      <div class="container">
        <h3>Videos to watch</h3>
        <app-carousal-page [genericCarousel]="true" [carouselSlideData]="categoryData.mediaList">
        </app-carousal-page>
      </div>
    </div>
  </div>
</div>
<div [innerHtml]="structuredData"></div>
